import { EventEmitter, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { AuthService } from '../shared/auth.service';
import { PeriodoValidezDto, Proyecto, Proyecto_Reserva_Horarios, ProyectoDirecciones, ProyectoLineaDto, ProyectoReglaComision, ProyectoReservaReglaDTO, RecuperaProyectosDTO } from '../models/proyecto';
import { SistemaVentasProyectos } from '../models/SistemaVentasProyectos';
import { environment } from 'src/environments/environment';
import { UsuarioProyecto } from '../models/usuarioProyecto';
import { Usuario } from '../models/usuario';
import { Tabulacion } from '../models/tabulacion';
import { Lote_Reserva_ReglasHorario, ProyectosLote } from '../models/proyectos_lote';
import { ModeloProyecto } from '../models/modeloProyecto';
import { MesaTrabajo } from '../models/mesa-trabajo';
import { ComisionPorApartado } from '../models/comisionPorApartado';
import { HttprService } from '../shared/httpr.service';
import { Modelo } from '../models/modelo';
import { ProyectosLoteListaPrecios } from '../models/proyectoListaDinamica';
import { ModeloEquipamiento } from '../models/modelo-equipamiento';
import { VentajaProyecto } from '../models/ventaja-proyecto';
import { LandingProyecto } from '../models/landing-proyecto';
import { FilePondFile } from 'filepond';
import { Promocion } from '../models/promocion';
import { ConvenioProyectos } from '../models/convenio/convenio';
import { FormGroup } from '@angular/forms';
import { ProyectosConfiguracionComisiones } from '../models/proyectos/ProyectosConfiguracionComisiones';
import { Proyecto_Anticipo_Liquidacion } from '../models/proyectos/proyectoAnticipoLiquidacion';
import { ProyectoDispersionDetalle } from '../models/proyectos/proyectoDispersion';
import { ProyectoAccesoCategoria } from '../models/proyectos/proyectosAccesoCategoria';
import * as moment from 'moment';
import { PermisosAdicionales } from '../models/permisos_adicionales';
import { Equipamiento } from '../models/equipamiento';
import { GuardaProcesoTarea, Proceso, ProcesoLink, ProcesosValidadoEstatus } from '../models/proceso';
import { ExcelInventario } from '../models/excel/excelModelo';
import { ConjuntoProyecto } from '../models/conjuntoProyecto/conjuntoProyecto';
import { ConjuntoProyectoProyecto } from '../models/conjuntoProyecto/conjuntoProyectoProyecto';
import { InfoProyectoRequest, ProgresoProyectoInfo, Proyecto_Renta_Categoria, Proyecto_Renta_Categoria_Lote } from '../models/proyectos/proyectosDTO';
import { responseZIPcode } from '../models/codigoPostales/codigoPostales';
import { LineasProducto } from '../models/lineaProducto/LineaProducto';
import { CategoriasBS } from './categoriaBs/categoriaBs';
import { ProyectoProducto } from '../models/lineaProducto/proyectoProducto';
import { EliminarArchivoRequest } from '../models/lineaProducto/eliminarArchivosRequest';
import { CatalogoTabla } from '../models/catalogoTablas';
import { RequestNombre, requestOrder } from '../models/proyectos/requestOrder';
import { Proceso_Proyecto_BodyPersonFoda, ProcesoProyectoBodyPersonPreguntas, Proyectos_Configuracion_Extra } from '../models/bodyPerson';
import { Lote_Reserva_Precios, ProyectoLoteModelo } from '../models/modeloProyecto/modeloProyectoLote';
import { CodigosSAT } from '../models/lineaProducto/codigosSAT';


@Injectable({ providedIn: 'root' })
export class ProyectoService {
  usuarioLogeado: Usuario;
  proyecto = new Subject<Proyecto>();
  mesa = new Subject<MesaTrabajo>();
  modeloNuevo = new Subject<Modelo>();
  modelo: Modelo;
  proyectoSelected = new Proyecto();
  addProyecto = new Subject<Proyecto>();

  // Un Subject para notificar cuándo iniciar el tour
  private startTourSubjectMarketing = new Subject<void>();
  // Observable que otros componentes pueden suscribirse
  startTourMarketing$ = this.startTourSubjectMarketing.asObservable();

  private modeloIdSource = new Subject<any>(); // Fuente de datos para emitir
  modeloId$ = this.modeloIdSource.asObservable(); // Observable para escuchar

  private cerrarModeloSource = new Subject<void>();
  cerrarModelo$ = this.cerrarModeloSource.asObservable();

  public modeloIdSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  modeloIdEmitido: boolean = false;

  constructor(private http: HttpClient, private httpr: HttprService) {
  }

  private Cabezera() {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.usuarioLogeado.token}`
    })
  }

  async guardaProyectos(form: FormGroup, logo: File) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);
    var url = environment.apiUrl;

    formData.append('logo', form.value.logo);
    formData.append('portada', form.value.portada);

    formData.append('IdProyecto', form.value.idProyecto.toString());
    formData.append('IdUsuarioUM', form.value.idUsuario.toString());
    formData.append('IdEmpresaAfiliada', form.controls['idEmpresaAfiliada'].value.idEmpresaAfiliada);
    formData.append('Nombre', form.value.nombre);
    formData.append('Direccion', form.value?.ubicacion.description);
    formData.append('Latitud', form.value?.latitud == null ? "0" : form.value?.latitud);
    formData.append('Longitud', form.value?.longitud == null ? "0" : form.value?.longitud);
    formData.append('Tipo', form.controls['tipo'].value.valor);
    formData.append('Inventario', form.value?.inventario);


    return this.http.post<Proyecto>(url + "/proyectos/guarda-proyectos", formData, { headers }).pipe(map((data: Proyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async guardaProyectoPendiente(form: FormGroup) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;


    formData.append('logo', form.value.logo);
    formData.append('portada', form.value.portada);

    formData.append('IdProyecto', form.value.idProyecto.toString());
    formData.append('IdUsuarioUM', form.value.idUsuario.toString());
    formData.append('IdEmpresaAfiliada', form.controls['idEmpresaAfiliada'].value);
    formData.append('Nombre', form.controls['nombreProyecto'].value);
    formData.append('Direccion', form.controls['direccion'].value);
    formData.append('Latitud', form.controls['latitud'].value);
    formData.append('Longitud', form.controls['longitud'].value);
    formData.append('Tipo', form.controls['tipoProyecto'].value.valor);
    formData.append('Inventario', form.controls['inventario'].value);
    formData.append('Estatus', form.controls['estatus'].value);

    formData.append('Descripcion', form.controls['descripcionProyecto'].value);
    formData.append('TipoVenta', form.controls['tipoVenta'].value.valor);
    formData.append('FechaEntrega', moment(form.controls['tiempoEntrega'].value.toString()).format('YYYY-MM-DD'));



    return this.http.post<Proyecto>(url + "/proyectos/guarda-proyecto-pendiente", formData, { headers }).pipe(map((data: Proyecto) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  notificaProyectpoPendiente(usuario: Usuario) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    //create body

    var body = {
      IdUsuario: usuario.idUsuario,
      Login: usuario.login,
      Nombre: usuario.nombre,
    }

    return this.http.post((url + "/proyectos/notifica-proyecto-pendiente"), body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    );
  }

  recuperaProyectoInteres(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-proyecto-interes"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaProyectoModelos(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;
    return this.http.post((url + "/proyectos/recupera-modelo"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Equipamiento[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  async recuperaProyectoEquipamientosAsync(proyecto: Proyecto = new Proyecto()) {
    try {
      this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));
      const url = environment.apiUrl;

      const response = await this.http.post(
        `${url}/proyectos/recupera-equipamientos`,
        proyecto,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.usuarioLogeado.token}`
          }),
        }
      ).toPromise();

      return response;
    } catch (error) {
      throw error;
    }
  }

  guardaInteresProspecto(proyecto: Proyecto): Observable<Proyecto> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post<Proyecto>((url + "/proyectos/guarda-interes"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaProyectoUsuario(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))


    var url = environment.apiUrl;
    return this.http.post((url + "/proyectos/recupera-proyecto-usuario"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {

      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaModelos(proyecto: Proyecto | Modelo) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-modelos-web"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Modelo[]) => {

      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaEstatusModelo(modelo: Modelo) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/guarda-estatus-modelo"), modelo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Modelo) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaProyectosConjunto(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recuperaproyectosconjuntoV2"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaLandingProyecto(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-landing"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  async recuperaModeloProyecto(proyecto: Modelo) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-modelo"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ModeloProyecto[]) => {

      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  guardaListaDinamica(lista = new ProyectosLoteListaPrecios()) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    lista.idUsuarioUM = Number(this.usuarioLogeado.idUsuario);
    var url = environment.apiUrl;

    if (lista.idModelo < 1) {
      lista.idModelo = -1;
    }
    return this.httpr.POST<ProyectosLoteListaPrecios>("/proyectos/guarda-lista-dinamica", lista);
    // return await this.http.post((url + "/proyectos/guarda-lista-dinamica"), lista, {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${this.usuarioLogeado.token}`
    //   }),
    // }).pipe(map((data: ProyectosLoteListaPrecios) => {
    //   return data;
    // }),
    //   catchError(errorRes => {
    //     return throwError(errorRes);
    //   })
    // ).toPromise();
  }

  async eliminaListaDinamica(lista: ProyectosLoteListaPrecios) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    lista.idUsuarioUM = Number(this.usuarioLogeado.idUsuario);
    var url = environment.apiUrl;

    if (lista.idModelo < 1) {
      lista.idModelo = -1;
    }
    return await this.http.post((url + "/proyectos/elimina-lista-dinamica"), lista, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ProyectosLoteListaPrecios) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }


  async recuperaListaDinamica(IdProyecto: number, IdModelo: number, IdListaPrecios: number) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    //Body
    var body = {
      "IdProyecto": IdProyecto,
      "IdModelo": IdModelo,
      "IdListaPrecios": IdListaPrecios
    }

    return await this.http.post((url + "/proyectos/recupera-lista-dinamica"), body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ProyectosLoteListaPrecios[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }


  async recuperaProyectos(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    proyecto.idUsuario = -1;

    return await this.http.post((url + "/proyectos/recupera-proyecto"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  recuperaProyectosPendientes() {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    let params = new HttpParams();
    params = params.append('IdUsuario', this.usuarioLogeado.idUsuario.toString());

    return this.http.get<Proyecto[]>((url + "/proyectos/recupera-proyectos-pendientes"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  GetConfiguracionSVP(idProyecto: number) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/GetConfiguracionSVP"), { 'idProyecto': idProyecto }, {
      headers: this.Cabezera(),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  GetTabulacionComisiones(idProyecto: number): any {
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/GetTabulacionComisiones"), { 'idProyecto': idProyecto }, {
      headers: this.Cabezera(),
    });
  }

  TablaTabulacion_Agregar(tabulacion: Array<Tabulacion>, sistemaVentasProyectos: Array<SistemaVentasProyectos>) {
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/TablaTabulacion_Agregar"), { 'Tabulacion': tabulacion, 'SistemaVentasProyectos': sistemaVentasProyectos }, {
      headers: this.Cabezera(),
    });
  }

  async recuperaProyectosLote(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-lotes"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ProyectosLote[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async recuperaBrochure(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-brochure"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: MesaTrabajo) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async recuperaBrochureModelo(modelo: Modelo) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-brochure-modelo"), modelo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: MesaTrabajo) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async recuperaProyectosLanding(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-landing"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: LandingProyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async guardaLoteConfig(lote: ProyectosLote) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/guarda-lote-config"), lote, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ProyectosLote) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  async guardaModeloEquipamiento(me: ModeloEquipamiento) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/guarda-equipamientos-modelo"), me, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ModeloEquipamiento) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  async guardaModelo(mo: Modelo, file: File) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;

    formData.append('files', file);

    formData.append('IdProyecto', mo.idProyecto?.toString());
    formData.append('IdEmpresaAfiliada', mo.idEmpresaAfiliada?.toString());
    formData.append('IdModelo', mo.idModelo.toString());
    formData.append('PrecioModelo', mo.precioModelo?.toString());
    formData.append('Nombre', mo.nombre.toString());
    formData.append('Terreno', mo.terreno?.toString());
    formData.append('Construccion', mo.construccion?.toString());
    formData.append('Plantas', mo.plantas?.toString());
    formData.append('Recamaras', mo.recamaras?.toString());
    formData.append('Banos', mo.banos?.toString());
    formData.append('Estacionamientos', mo.estacionamientos?.toString());
    formData.append('Areas', mo.areas?.toString());
    formData.append('Descripcion', mo.descripcion?.toString());


    return this.http.post<Modelo>(url + "/proyectos/guarda-modelo", formData, { headers }).pipe(map((data: Modelo) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  async recuperaModeloEquipamiento(modelo: Modelo) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-equipamientos-modelo"), modelo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: ModeloEquipamiento[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  // guardaLotificacion(idProyecto: number, file: File) {
  //   var url = environment.apiUrl;
  //   this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

  //   const formData: any = new FormData();
  //   const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

  //   formData.append('files', file);
  //   formData.append('IdProyecto', idProyecto.toString());

  //   return this.http.post<MesaTrabajo>(url + "/proyectos/guarda-lotificacion", formData, { headers }).pipe(map((data: MesaTrabajo) => {
  //     return data;
  //   }),
  //     catchError(errorRes => {
  //       return throwError(errorRes);
  //     })
  //   );
  // }

  eliminaLotificacion(proyecto: Proyecto) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;
    //create body
    let body = {
      IdProyecto: proyecto.idProyecto,
    }
    return this.http.post<Proyecto>((url + "/proyectos/elimina-lotificacion"), body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    );
  }

  recuperaProyectoInteresSeguimiento(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-proyecto-interes-seguimiento"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaProyectosLoteListaDinamica(proyectosLoteLista = new ProyectosLoteListaPrecios()) {
    return this.httpr.POST<ProyectosLoteListaPrecios>("/proyectos/guardaProyectosLoteListaDinamica", proyectosLoteLista);
  }

  recuperaProyectosListaUnidades(proyectosLoteLista = new ProyectosLoteListaPrecios()) {
    return this.httpr.POST<ProyectosLoteListaPrecios>("/proyectos/recupera-Lista-Unidades", proyectosLoteLista);
  }

  //Guarda imagenes del proyecto
  async guardaImagenLandingProyecto(p: Proyecto, file: File) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);
    var url = environment.apiUrl;

    formData.append('files', file);
    formData.append('IdProyecto', p.idProyecto.toString());
    formData.append('TipoImagen', p.tipoImagen.toString());


    return this.http.post<Proyecto>(url + "/proyectos/guarda-img-landing-proyecto", formData, { headers }).pipe(map((data: Modelo) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  //Guarda imagenes del proyecto
  async eliminaImagenLandingProyecto(p: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);
    var url = environment.apiUrl;


    formData.append('IdProyecto', p.idProyecto.toString());
    formData.append('TipoImagen', p.tipoImagen.toString());


    return this.http.post<Proyecto>(url + "/proyectos/elimina-img-landing-proyecto", formData, { headers }).pipe(map((data: Modelo) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }


  recuperaVentajasProyecto(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-ventajas"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: VentajaProyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  //Guarda imagenes del proyecto
  async guardaVentajaProyecto(v: VentajaProyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;

    formData.append('IdProyecto', v.idProyecto.toString());
    formData.append('IdIcono', v.idIcono.toString());
    formData.append('IdEmpresaAfiliada', v.idEmpresaAfiliada?.toString());
    formData.append('Nombre', v.nombre.toString());


    return this.http.post<Proyecto>(url + "/proyectos/guarda-ventaja", formData, { headers }).pipe(map((data: VentajaProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }


  eliminaVentajaProyecto(ventaja: VentajaProyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/elimina-ventaja"), ventaja, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: VentajaProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaInfoLandingProyecto(landing: LandingProyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/recupera-info-landing"), landing, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: LandingProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaInfoProyecto(proyecto: Proyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/guarda-info-proyecto"), proyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaInfoLandingProyecto(landing: LandingProyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/guarda-info-landing"), landing, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: LandingProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaEquipamientoLanding(landing: LandingProyecto, files: File[]) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);
    var url = environment.apiUrl;

    files.forEach(file => {
      formData.append('files', file);
    });
    formData.append('IdProyecto', landing.idProyecto.toString());
    formData.append('IdLanding', landing.idLanding.toString());


    return this.http.post<LandingProyecto>(url + "/proyectos/guardaEquipamientoLanding", formData, { headers }).pipe(map((data: LandingProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  eliminaEquipamientoLanding(landing: LandingProyecto) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    return this.http.post((url + "/proyectos/eliminaEquipamientoLanding"), landing, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: LandingProyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaConveniosProyectos(convenio = new ConvenioProyectos()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/recupera-ConveniosProyectos", convenio);
  }

  guardaConveniosProyectos(convenio = new ConvenioProyectos()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/guardaConveniosProyectos", convenio);
  }

  eliminaConveniosProyectos(convenio = new ConvenioProyectos()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/eliminaConveniosProyectos", convenio);
  }

  recuperaReferencia(convenio = new ConvenioProyectos()) {
    return this.httpr.POST<ConvenioProyectos>("/pagos/recupera-ReferenciaPago", convenio);
  }

  eliminaLoteProyectosLote(proyectosLote = new ProyectosLote()) {
    return this.httpr.POST<ProyectosLote>("/proyectos/eliminaLoteProyectosLote", proyectosLote);
  }

  async guardaGaleriaProyecto(file: File, proyecto: Proyecto, nuevaImagen: boolean, eliminar: string[]) {
    try {
      const url = environment.apiUrl;
      this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));

      const formData: any = new FormData();
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

      formData.append(file.name, file);

      formData.append('IdProyecto', proyecto.idProyecto.toString());
      formData.append('IdEmpresaAfiliada', proyecto.idEmpresaAfiliada.toString());
      formData.append('CantidadGaleria', proyecto.cantidadGaleria.toString());

      if (nuevaImagen) {
        formData.append('Mensaje', "REEMPLAZAR");
      }

      const data = await this.http.post<Proyecto>(url + "/proyectos/guarda-galeria-proyecto", formData, { headers }).toPromise();
      return data;
    } catch (errorRes) {
      console.log(errorRes);
      throw errorRes;
    }
  }

  async eliminaGaleriaProyecto(file: File, proyecto: Proyecto, nuevaImagen: boolean, eliminar: string[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append(file.name, file);

    formData.append('IdProyecto', proyecto.idProyecto.toString());
    formData.append('IdEmpresaAfiliada', proyecto.idEmpresaAfiliada.toString());
    formData.append('CantidadGaleria', proyecto.cantidadGaleria.toString());


    try {
      const data: Modelo = await this.http.post<Modelo>(url + "/proyectos/elimina-galeria-proyecto", formData, { headers }).toPromise();
      return data;
    } catch (errorRes) {
      console.log(errorRes);
      throw errorRes;
    }
  }

  async guardaGaleriaModelo(file: File, modelo: Modelo, nuevaImagen: boolean, eliminar: string[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append(file.name, file);

    formData.append('IdProyecto', modelo.idProyecto.toString());
    formData.append('IdModelo', modelo.idModelo.toString());
    formData.append('IdEmpresaAfiliada', modelo.idEmpresaAfiliada.toString());
    formData.append('CantidadGaleria', modelo.cantidadGaleria.toString());
    formData.append('Eliminar', eliminar);

    console.log(formData, "formData");

    try {
      const data: Modelo = await this.http.post<Modelo>(url + "/proyectos/guarda-galeria-modelo", formData, { headers }).toPromise();
      return data;
    } catch (errorRes) {
      console.log(errorRes);
      throw errorRes;
    }
  }

  async guardarImagenes(imgTemporales: any, modelo: any, eliminados: any) {
    const copiaImagenes = imgTemporales;
    console.log(copiaImagenes, "copiaImagenes");
    console.log(modelo, "modelo");
    console.log(eliminados, "eliminados");
    //const copiaImagenes = this.imagenesTemporalExistentes;
    try {
      console.log(copiaImagenes)
      for (const [index, imagen] of copiaImagenes.entries()) {
        // this.nuevaImagen = true;

        try {
          console.log(imagen, modelo)
          // Llamada al servicio para guardar la imagen
          const res = await this.guardaGaleriaModeloInicial(
            imagen,
            modelo,
            true,
            []
          );

          if (res) {
            console.log(`Imagen ${index + 1} guardada exitosamente:`, res);
          }
        } catch (error) {
          console.error(`Error al guardar la imagen ${index + 1}:`, error);
          // Opcional: Manejo de errores individuales (no detiene el bucle)
        }

        // Resetear el estado de imgGuardando después de cada intento
        // this.imgGuardando = "";
      }

      // Limpiar imágenes temporales al finalizar
      // this.imagenesTemporalExistentes = [];
      // this.proyectosService.cerrarModelo();
    } catch (error) {
      console.error('Error general durante el proceso:', error);
    }


    // const copiaImagenes = this.imagenesTemporalExistentes;
    // console.log("copuas totales", copiaImagenes);
    // try {
    //   for (const [index, imagen] of copiaImagenes.entries()) {
    //     this.nuevaImagen = true;

    //     try {
    //       const res = await this.proyectosService.guardaGaleriaModeloInicial(imagen, this.modelo, this.nuevaImagen, this.eliminados);
    //       this.imgGuardando = "";
    //     } catch (err) {
    //       this.cargando = false;
    //     }
    //   }
    //   this.imagenesTemporalExistentes = [];
    //   this.proyectosService.cerrarModelo();
    // } catch (error) {
    //   console.error('Error general durante el guardado de imágenes:', error);
    // }
  }

  async guardaGaleriaModeloInicial(file: File, modelo: Modelo, nuevaImagen: boolean, eliminar: string[]) {
    const url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));
    if (!this.usuarioLogeado?.token) {
      console.error('No se encontró el token del usuario logeado.');
      return;
    }

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append(file.name, file);
    formData.append('IdProyecto', modelo.idProyecto?.toString());
    formData.append('IdModelo', modelo.idModelo?.toString());
    formData.append('IdEmpresaAfiliada', modelo.idEmpresaAfiliada?.toString());
    formData.append('CantidadGaleria', modelo.cantidadGaleria?.toString());
    formData.append('Eliminar', eliminar);

    try {
      const data: Modelo = await this.http.post<Modelo>(
        `${url}/proyectos/guarda-galeria-modelo`,
        formData,
        { headers }
      ).toPromise();
      console.log('Respuesta de la API:', data);
      return data;
    } catch (errorRes) {
      console.error('Error en la llamada a la API:', errorRes);
      throw errorRes;
    }
  }

  async eliminaGaleriaModelo(file: File, modelo: Modelo, nuevaImagen: boolean, eliminar: string[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append(file.name, file);

    formData.append('IdProyecto', modelo.idProyecto.toString());
    formData.append('IdModelo', modelo.idModelo.toString());
    formData.append('IdEmpresaAfiliada', modelo.idEmpresaAfiliada.toString());
    formData.append('CantidadGaleria', modelo.cantidadGaleria.toString());
    formData.append('Eliminar', eliminar);


    try {
      const data: Modelo = await this.http.post<Modelo>(url + "/proyectos/elimina-galeria-modelo", formData, { headers }).toPromise();
      return data;
    } catch (errorRes) {
      console.log(errorRes);
      throw errorRes;
    }
  }

  async eliminaPortadaModelo(file: File, modelo: Modelo, nuevaImagen: boolean, eliminar: string[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append(file.name, file);

    formData.append('IdProyecto', modelo.idProyecto.toString());
    formData.append('IdModelo', modelo.idModelo.toString());
    formData.append('IdEmpresaAfiliada', modelo.idEmpresaAfiliada.toString());
    formData.append('Eliminar', eliminar);

    try {
      const data: Modelo = await this.http.post<Modelo>(url + "/proyectos/elimina-portada-modelo", formData, { headers }).toPromise();
      return data;
    } catch (errorRes) {
      console.log(errorRes);
      throw errorRes;
    }
  }


  guardaBrochureModelo(file: File, modelo: Modelo) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append('files', file);
    formData.append('IdProyecto', modelo.idProyecto.toString());
    formData.append('IdModelo', modelo.idModelo.toString());
    formData.append('IdEmpresaAfiliada', modelo.idEmpresaAfiliada.toString());
    formData.append('IdPromocion', modelo.idPromocion.toString());

    return this.http.post<Modelo>(url + "/proyectos/guarda-brochure-modelo", formData, { headers }).pipe(map((data: Modelo) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    );

  }

  guardaProyectosConfiguracionComisiones(proyectosConfiguracionComisiones = new ProyectosConfiguracionComisiones()) {
    return this.httpr.POST<ProyectosConfiguracionComisiones>("/proyectos/guarda-Proyectos-configuracion-Comisiones", proyectosConfiguracionComisiones);
  }

  recuperaProyectosConfiguracionComisiones(proyectosConfiguracionComisiones = new ProyectosConfiguracionComisiones()) {
    return this.httpr.POST<ProyectosConfiguracionComisiones>("/proyectos/recupera-Proyectos-Configuracion-Comisiones", proyectosConfiguracionComisiones);
  }

  recuperaProyectosAnticipoLiquidaciones(proyecto_Anticipo_Liquidacion = new Proyecto_Anticipo_Liquidacion()) {
    return this.httpr.POST<Proyecto_Anticipo_Liquidacion[]>("/proyectos/recupera-Proyectos-Anticipo-Liquidaciones", proyecto_Anticipo_Liquidacion);
  }

  guardaProyectosAnticipoLiquidacion(proyecto_Anticipo_Liquidacion = new Proyecto_Anticipo_Liquidacion()) {
    return this.httpr.POST<ProyectosConfiguracionComisiones>("/proyectos/guarda-Proyectos-Anticipo-Liquidacion", proyecto_Anticipo_Liquidacion);
  }

  eliminaAnticipoLiquidacion(proyecto_Anticipo_Liquidacion = new Proyecto_Anticipo_Liquidacion()) {
    return this.httpr.POST<Proyecto_Anticipo_Liquidacion>("/proyectos/elimina-Proyectos-Anticipo-Liquidacion", proyecto_Anticipo_Liquidacion);
  }

  recuperaProyectoDispersion(proyectoDispersionDetalle = new ProyectoDispersionDetalle()) {
    return this.httpr.POST<ProyectoDispersionDetalle>("/proyectos/recupera-Proyectos-Dispersion", proyectoDispersionDetalle);
  }

  guardaProyectoUsuario(proyecto = new UsuarioProyecto()) {
    return this.httpr.POST<Proyecto>("/proyectos/guarda-proyecto-usuario", proyecto);
  }

  visualizaProyecto(proyectoAccesoCategoria = new ProyectoAccesoCategoria()) {
    return this.httpr.POST<ProyectoAccesoCategoria>("/proyectos/visualiza-proyecto", proyectoAccesoCategoria);
  }

  recuperaVisualizaProyecto(proyectoAccesoCategoria = new ProyectoAccesoCategoria()) {
    return this.httpr.POST<ProyectoAccesoCategoria[]>("/proyectos/recupera-visualiza-proyecto", proyectoAccesoCategoria);
  }

  recuperaUnidadesCambioLista(proyecto = new Proyecto()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/recupera-unidadescambiolista-proyecto", proyecto);
  }

  recuperaPermisosAdicionales(idUsuario: number, idProyecto: number) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    let params = new HttpParams();
    params = params.append('idUsuario', idUsuario.toString());
    params = params.append('idProyecto', idProyecto.toString());

    return this.http.get<PermisosAdicionales>((url + "/proyectos/recupera-permisos-adicionales"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(map((data: PermisosAdicionales) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  guardaPermisosAdicionales(permisos: PermisosAdicionales): Observable<PermisosAdicionales> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post<PermisosAdicionales>((url + "/proyectos/guarda-permisos-adicionales"), permisos, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  activaProyectoMasterComercial(usuario: Usuario): Observable<Proyecto> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return this.http.post<Proyecto>((url + "/proyectos/activa-proyecto-master-comercial"), usuario, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  actualizaUnidadesVendidasProyecto(proyecto = new Proyecto()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/actualiza-unidades-proyecto", proyecto);
  }

  actualizaEstatusIncrementoLista(proyectosLoteListaPrecios = new ProyectosLoteListaPrecios()) {
    return this.httpr.POST<ConvenioProyectos>("/proyectos/actualiza-estatus-incremento-proyectoListaPrecios", proyectosLoteListaPrecios);
  }

  async guardaProcesoProyecto(proceso: Proceso): Promise<Proceso> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));

    var url = environment.apiUrl;

    try {
      const resultado = await this.http.post<Proceso>((url + "/procesos/guarda-proceso"), proceso, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.usuarioLogeado.token}`
        }),
      }).toPromise();
      return resultado;
    } catch (errorRes) {
      throw errorRes;
    }
  }

  guardaTareaProceso(proceso: GuardaProcesoTarea) {
    return this.httpr.POST<GuardaProcesoTarea>("/procesos/guarda-tarea-proceso", proceso);
  }

  async importarProcesosProyecto(proceso: Proceso): Promise<Proceso[]> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));

    var url = environment.apiUrl;

    try {
      const resultado = await this.http.post<Proceso[]>((url + "/procesos/importar-procesos"), proceso, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.usuarioLogeado.token}`
        }),
      }).toPromise();
      return resultado;
    } catch (errorRes) {
      throw errorRes;
    }
  }


  recuperaProcesosProyecto(idProyecto: number) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    let params = new HttpParams();
    params = params.append('idProyecto', idProyecto.toString());

    return this.http.get<Proceso[]>((url + "/procesos/recupera-procesos"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(map((data: Proceso[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  async eliminaProcesoProyecto(proceso: Proceso): Promise<Proceso> {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));

    var url = environment.apiUrl;

    try {
      const resultado = await this.http.post<Proceso>((url + "/procesos/elimina-proceso"), proceso, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.usuarioLogeado.token}`
        }),
      }).toPromise();
      return resultado;
    } catch (errorRes) {
      throw errorRes;
    }
  }

  guardarExcelImportarInventario(excelInventario: ExcelInventario[]) {
    return this.httpr.POST<ExcelInventario[]>("/proyectos/guarda-excel-importar-inventario", excelInventario);
  }

  recuperaConjuntos(conjuntoProyecto = new ConjuntoProyecto()) {
    return this.httpr.POST<ConjuntoProyecto[]>("/proyectos/recupera-conjuntos-proyecto", conjuntoProyecto);
  }

  guardaConjuntoProyecto(conjuntoProyecto = new ConjuntoProyecto()) {
    return this.httpr.POST<ConjuntoProyecto[]>("/proyectos/guarda-conjuntos-proyecto", conjuntoProyecto);
  }

  async recuperaConjuntoProyectoProyecto(conjuntoProyectoProyecto = new ConjuntoProyectoProyecto()) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    return await this.http.post((url + "/proyectos/recupera-conjuntos-proyecto-proyecto"), conjuntoProyectoProyecto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }),
    }).pipe(map((data: Proyecto[]) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
    //return this.httpr.POST<Proyecto[]>("/proyectos/recupera-conjuntos-proyecto-proyecto", conjuntoProyectoProyecto);
  }

  eliminarConjuntoProyecto(conjuntoProyecto = new ConjuntoProyecto()) {
    return this.httpr.POST<ConjuntoProyecto[]>("/proyectos/elimina-conjuntos-proyecto", conjuntoProyecto);
  }

  incrementoLotePrecioFinal(proyectolote = new ProyectosLote()) {
    return this.httpr.POST<ProyectosLote>("/proyectos/actualizaIncrementoPrecioFinal", proyectolote);
  }

  eliminaEquipamientoModelo(modeloEquipamiento = new ModeloEquipamiento()) {
    return this.httpr.POST<ModeloEquipamiento>("/proyectos/eliminaEquipamientoModelo", modeloEquipamiento);
  }

  recuperaProgresoProyectos(proyecto: InfoProyectoRequest) {
    let params = new HttpParams();
    params = params.append("IdProyecto", proyecto.idProyecto.toString());
    params = params.append("TipoProyecto", proyecto.tipoProyecto.toString());


    return this.httpr.GET<ProgresoProyectoInfo[]>("/proyectos/obtener-progreso-proyectos", params);
  }

  recuperaProyectoBS(proyecto = new RecuperaProyectosDTO()) {
    let params = new HttpParams();
    params = params.append("IdProyecto", proyecto.idProyecto?.toString());
    params = params.append("IdEmpresaAfiliada", proyecto.idEmpresaAfiliada?.toString());
    params = params.append("IdUsuario", proyecto.idUsuario?.toString());
    params = params.append("Estatus", proyecto.estatus?.toString());
    params = params.append("Tipo", proyecto.tipo?.toString());

    return this.httpr.GET<Proyecto[]>("/EmpresasAfiliadasBS/recupera-proyecto-bs", params);
  }

  guardaPdfLotificacion(idProyecto: number, file: File) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    formData.append('files', file);
    formData.append('IdProyecto', idProyecto.toString());

    return this.http.post<MesaTrabajo>(url + "/proyectos/guarda-lotificacion", formData, { headers }).pipe(map((data: MesaTrabajo) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaProyectoBs(proyecto = new Proyecto(), file: File[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);

    file.forEach((element, index) => {
      let fileNameWithoutExtension = element.name.split('.').slice(0, -1).join('.');
      formData.append(fileNameWithoutExtension, element);
    });


    formData.append('IdEmpresaAfiliada', proyecto.idEmpresaAfiliada?.toString());
    formData.append('IdProyecto', proyecto.idProyecto?.toString());
    formData.append('Nombre', proyecto.nombre?.toString());
    formData.append('latitud', proyecto.latitud?.toString());
    formData.append('longitud', proyecto.longitud?.toString());
    formData.append('Tipo', proyecto.tipo?.toString());
    formData.append('Descripcion', proyecto.descripcion?.toString());
    formData.append('Direccion', proyecto.direccion?.toString());
    formData.append('IdUsuario', proyecto.idUsuario?.toString());
    formData.append('IdUsuarioUM', proyecto.idUsuario?.toString());
    formData.append('IdCiudad', proyecto.idCiudad?.toString());
    formData.append('Telefono', proyecto.telefono?.toString());
    formData.append('Lada', proyecto.lada?.toString());
    formData.append('TipoProyecto', proyecto.tipoProyecto?.toString());
    formData.append('TipoDivisa', proyecto.tipoDivisa?.toString());
    formData.append('Calle', proyecto.calle?.toString());
    formData.append('Colonia', proyecto.colonia?.toString());
    formData.append('CodigoPostal', proyecto.codigoPostal?.toString());
    formData.append('Numero', proyecto.numero?.toString());

    formData.append('necesidadResuelve', proyecto.necesidadResuelve?.toString());
    formData.append('comoAyudas', proyecto.comoAyudas?.toString());
    formData.append('porQueEsEspecial', proyecto.porQueEsEspecial?.toString());


    return this.http.post<Proyecto>(url + "/empresasafiliadasBS/guarda-proyectos-bs", formData, { headers }).pipe(map((data: Proyecto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaCiudadCodigoPostal(codigPostal: string = "") {
    var params = new HttpParams();
    params = params.append("ZipCode", codigPostal);

    return this.httpr.GET<responseZIPcode>("/proyectos/obtener-ubicacion-cp", params);
  }

  recuperaLineasProductos(proyecto = new Proyecto()) {
    var params = new HttpParams();
    params = params.append("IdProyecto", proyecto.idProyecto.toString());

    return this.httpr.GET<LineasProducto[]>("/empresasafiliadasBS/obtener-lineas-producto", params);
  }

  guardaCategoriaLineaProducto(categoriaLineaProducto = new CategoriasBS()) {
    return this.httpr.POST<CategoriasBS>("/empresasafiliadasBS/guarda-categoria-bs", categoriaLineaProducto);
  }

  recuperaCategoriasLineaProducto(proyecto: number) {
    var params = new HttpParams();
    params = params.append("IdProyecto", proyecto.toString());

    return this.httpr.GET<CategoriasBS[]>("/empresasafiliadasBS/obtener-categorias", params);
  }

  guardaLineaProducto(lineaProducto = new LineasProducto(), file: File[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    file.forEach((element, index) => {
      formData.append("files", element);  // Se añade cada archivo al FormData
    });

    formData.append('IdLineaProductos', lineaProducto.idLineaProductos?.toString());
    formData.append('IdProyecto', lineaProducto.idProyecto?.toString());
    formData.append('IdEmpresaAfiliada', lineaProducto.idEmpresaAfiliada?.toString());
    formData.append('IdCategoria', "-1");
    formData.append('Nombre', lineaProducto.nombre?.toString());
    formData.append('Descripcion', lineaProducto.descripcion?.toString());
    formData.append('Estatus', lineaProducto.estatus?.toString());

    return this.http.post<LineasProducto>(url + "/empresasafiliadasBS/guarda-linea-producto", formData, { headers }).pipe(map((data: LineasProducto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaProductosLineaProducto(lineaProducto: ProyectoProducto) {
    var params = new HttpParams();
    params = params.append("IdProyecto", lineaProducto.idProyecto.toString());
    params = params.append("IdLinea", lineaProducto.idLineaProducto.toString());
    params = params.append("IdProducto", lineaProducto.idProducto.toString());
    params = params.append("Estatus", lineaProducto.estatus.toString());

    return this.httpr.GET<ProyectoProducto[]>("/empresasafiliadasBS/obtener-productos", params);
  }

  guardaProductoProyectos(proyectoProducto: ProyectoProducto, file: File[]) {
    var url = environment.apiUrl;
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado.token}`);

    file.forEach((element, index) => {
      formData.append("files", element);  // Se añade cada archivo al FormData
    });

    formData.append('IdProducto', proyectoProducto.idProducto?.toString());
    formData.append('IdLineaProducto', proyectoProducto.idLineaProducto?.toString());
    formData.append('IdProyecto', proyectoProducto.idProyecto?.toString());
    formData.append('Nombre', proyectoProducto.nombre?.toString());
    formData.append('Descripcion', proyectoProducto.descripcion?.toString());
    formData.append('PrecioUnitario', proyectoProducto.precioUnitario?.toString());
    formData.append('PrecioConDescuento', proyectoProducto.precioConDescuento?.toString());
    formData.append('Estatus', proyectoProducto.estatus.toString());
    formData.append('Stock', proyectoProducto.stock?.toString());
    formData.append('largo', (proyectoProducto.largo ?? 0).toString());
    formData.append('ancho', (proyectoProducto.ancho ?? 0).toString());
    formData.append('alto', (proyectoProducto.alto ?? 0).toString());
    formData.append('peso', (proyectoProducto.peso ?? 0).toString());
    formData.append('ClaveUnidadPeso', (proyectoProducto.claveUnidadPeso ?? "").toString());
    formData.append('ClaveProdServ', (proyectoProducto.claveProdServ ?? "").toString());
    formData.append('stockIlimitado', (proyectoProducto.stockIlimitado ?? 0).toString());

    console.log(JSON.stringify(formData));
    return this.http.post<ProyectoProducto>(url + "/empresasafiliadasBS/guarda-proyecto-producto", formData, { headers }).pipe(map((data: ProyectoProducto) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  eliminaImagenLineaProducto(eliminarArchivoRequest: EliminarArchivoRequest) {
    return this.httpr.POST<string>("/empresasafiliadasBS/eliminar-archivos", eliminarArchivoRequest);
  }

  eliminaLogosProyectos(eliminarArchivoRequest: EliminarArchivoRequest) {
    return this.httpr.POST<string>("/EmpresasAfiliadasBS/eliminar-archivos-bloque", eliminarArchivoRequest);
  }

  recuperaCiudadCatalogoTablas(ciudad = new RequestNombre()) {
    var params = new HttpParams();
    params = params.append("NombreCiudad", ciudad.nombreCiudad);

    return this.httpr.GET<CatalogoTabla>("/EmpresasAfiliadasBS/recupar-idciudad", params);
  }

  actualizaOrdenProcesos(proceso: any) {
    return this.httpr.POST<Proceso>("/procesos/cambiar-orden-proceso", proceso);
  }

  recuperaTareaProceso(guardaProcesoTarea: GuardaProcesoTarea) {
    return this.httpr.POST<GuardaProcesoTarea>("/procesos/recupera-tarea-proceso", guardaProcesoTarea);
  }

  guardaProcesoLink(procesoLink: ProcesoLink) {
    return this.httpr.POST<ProcesoLink>("/procesos/guarda-proceso-links", procesoLink);
  }

  recuperaProcesoLink(procesoLink: ProcesoLink) {
    return this.httpr.POST<ProcesoLink>("/procesos/recupera-proceso-links", procesoLink);
  }

  recuperaPreguntasBodyPerson(procesoProyectoBodyPersonPreguntas: ProcesoProyectoBodyPersonPreguntas) {
    var params = new HttpParams();
    params = params.append("IdProyecto", procesoProyectoBodyPersonPreguntas.idProyecto.toString());
    params = params.append("IdProceso", procesoProyectoBodyPersonPreguntas.idProceso.toString());

    return this.httpr.GET<ProcesoProyectoBodyPersonPreguntas[]>("/procesos/Recupera-BodyPerson-Catalogo-Preguntas", params);
  }

  guardaPreguntasBodyPerson(procesoProyectoBodyPersonPreguntas: ProcesoProyectoBodyPersonPreguntas) {
    return this.httpr.POST<ProcesoProyectoBodyPersonPreguntas>("/procesos/Guarda-BodyPerson-Catalogo-Preguntas", procesoProyectoBodyPersonPreguntas);
  }

  recuperaPreguntasBodyPersonFoda(procesoProyectoBodyPersonPreguntas: Proceso_Proyecto_BodyPersonFoda) {
    var params = new HttpParams();
    params = params.append("IdProyecto", procesoProyectoBodyPersonPreguntas.idProyecto.toString());
    params = params.append("Estatus", procesoProyectoBodyPersonPreguntas.estatus.toString());

    return this.httpr.GET<Proceso_Proyecto_BodyPersonFoda[]>("/procesos/Recupera-BodyPerson-Preguntas-Foda", params);
  }

  guardaPreguntasBodyPersonFoda(procesoProyectoBodyPersonPreguntas: Proceso_Proyecto_BodyPersonFoda) {
    return this.httpr.POST<Proceso_Proyecto_BodyPersonFoda>("/procesos/Guarda-BodyPerson-Preguntas-Foda", procesoProyectoBodyPersonPreguntas);
  }

  // Método para iniciar el tour
  startTourMarketing() {
    this.startTourSubjectMarketing.next();
  }

  emitirModeloId(modelo: any) {
    this.modeloIdSource.next(modelo); // Emite el ID del modelo
  }

  cerrarModelo() {
    this.cerrarModeloSource.next(); // Emite el evento de cerrar modelo
  }

  async guardaModeloLoteUnidad(mo = new ProyectoLoteModelo(), file: File) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;


    formData.append('files', file);
    formData.append('IdEmpresaAfiliada', mo.idEmpresaAfiliada?.toString());
    formData.append('IdProyecto', mo.idProyecto?.toString());
    formData.append('IdModelo', mo.idModelo?.toString());
    formData.append('IdLote', mo.idLote?.toString());
    formData.append('Nombre', mo.nombre?.toString());
    formData.append('m2', mo.m2?.toString());
    formData.append('areas', mo.areas?.toString());
    formData.append('recorrido', mo.recorrido?.toString());
    formData.append('cantidadGaleria', mo.cantidadGaleria?.toString());
    formData.append('recamaras', mo.recamaras?.toString());
    formData.append('banos', mo.banos?.toString());
    formData.append('estacionamientos', mo.estacionamientos?.toString());
    formData.append('descripcion', mo.descripcion?.toString());
    formData.append('ubicacion', mo.ubicacion?.toString());
    formData.append('latitud', mo.latitud?.toString());
    formData.append('longitud', mo.longitud?.toString());
    formData.append('estatus', mo.estatus?.toString());
    formData.append('precioFinal', mo.precioFinal?.toString());
    formData.append('formaRenta', mo.formaRenta?.toString());
    formData.append('idCategoria', mo.idCategoria?.toString());
    formData.append('idInfraestructura', mo.idInfraestructura?.toString());
    formData.append('nombreInfraestructura', mo.nombreInfraestructura?.toString());

    return this.http.post<any>(url + "/proyectos/guarda-Lotes-proyectoUnidad", formData, { headers }).pipe(map((data: any) => {
      return data;
    }),
      catchError(errorRes => {
        console.log(errorRes);

        return throwError(errorRes);
      })
    ).toPromise();
  }

  checkImageExistence(imageUrl: string) {
    return this.http.head(imageUrl, { observe: 'response' }).pipe(
      map(response => {
        return response.status === 200 && +response.headers.get('content-length') > 0;
      }),
      catchError(() => of(false))
    );
  }

  recuperaProyectosConfiguracionExtra(proyectoConfiguracionExtra: Proyectos_Configuracion_Extra) {
    return this.httpr.POST<Proyectos_Configuracion_Extra>("/proyectos/recupera-Proyecto-Configuracion-Extra", proyectoConfiguracionExtra);
  }

  habilitaPermisosProcesos(proyectoConfiguracionExtra: Proyectos_Configuracion_Extra) {
    return this.httpr.POST<Proyectos_Configuracion_Extra>("/proyectos/guarda-Proyecto-Configuracion-Extra", proyectoConfiguracionExtra);
  }

  // Método para obtener el observable
  obtenerModeloIdGaleria$(): Observable<number> {
    return this.modeloIdSubject.asObservable();
  }

  recuperaCodigosSATBs(codigosSAT = new CodigosSAT()) {
    return this.httpr.POST<CodigosSAT[]>("/EmpresasAfiliadasBS/recuperar-codigosSat-bs", codigosSAT);
  }

  guardaProyectoDirecciones(proyectoDirecciones = new ProyectoDirecciones()) {
    return this.httpr.POST<ProyectoDirecciones[]>("/proyectos/guarda-Proyecto-proyectoDirecciones", proyectoDirecciones);
  }

  recuperaCategoriasRentas(categoria = new Proyecto_Renta_Categoria()) {
    return this.httpr.POST<any[]>("/proyectos/recupera-proyecto-renta-categoria", categoria);
  }

  agregarCategoriaRenta(categoria = new Proyecto_Renta_Categoria()) {
    return this.httpr.POST<any[]>("/proyectos/guarda-proyecto-renta-categoria", categoria);
  }

  guardaCategoriaRentaLote(categoria = new Proyecto_Renta_Categoria_Lote()) {
    return this.httpr.POST<any[]>("/proyectos/guarda-proyecto-renta-categoria-lote", categoria);
  }

  eliminaListaDinamicaTotal(lista = new ProyectosLoteListaPrecios()) {
    return this.httpr.POST<any[]>("/proyectos/elimina-lista-dinamica-total", lista);
  }

  publicarProyectoMarketplace(marketplaceData: any) {
    return this.httpr.POST<any>("/proyectos/publicar-proyecto-marketplace", marketplaceData);
  }

  recuperaDetallesPublicacionMarket(idProyecto: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    return this.httpr.GET<any>("/proyectos/recupera-detalles-publicacion-market", params);
  }

  guardaProyectoAutomatizacion(proyectoLineaDto: ProyectoLineaDto) {
    return this.httpr.POST<any>("/proyectos/guardar-proyecto-linea-automatizacion", proyectoLineaDto);
  }

  eliminaProyectoAutomatizacion(proyectoLineaDto: ProyectoLineaDto) {
    return this.httpr.POST<any>("/proyectos/eliminar-proyecto-automatizacion", proyectoLineaDto);
  }

  recuperaProyectosLinea(proyectoLineaDto: ProyectoLineaDto) {
    var params = new HttpParams();
    params = params.append("idProyecto", proyectoLineaDto.idProyecto.toString());
    params = params.append("idLinea", proyectoLineaDto.idLinea.toString());
    params = params.append("idAutomatizacion", proyectoLineaDto.idAutomatizacion.toString());

    return this.httpr.GET<any>("/proyectos/recupera-proyectos-linea-automatizacion", params);
  }

  recuperaReglasComisionesProyecto(idProyecto: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    return this.httpr.GET<any>("/proyectos/recupera-reglas-comisiones-proyecto", params);
  }

  guardarProyectosComisiones(comision = new ProyectoReglaComision()) {
    return this.httpr.POST<ProyectoReglaComision>("/proyectos/guardar-proyectos-comisiones", comision);
  }

  recuperaReglasComisionesProyectoDisponibles(idProyecto: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    return this.httpr.GET<any>("/proyectos/recupera-reglas-comisiones-proyecto-disponibles", params);
  }

  guardarProyectosComisionesCombinaciones(combinacion: any) {
    return this.httpr.POST<any>("/proyectos/guardar-combinacion-proyectos-comision", combinacion);
  }

  eliminarProyectosComisionesCombinaciones(idCombinacion: number) {
    return this.httpr.POST<any>("/proyectos/eliminar-combinacion-proyectos-comision", { idCombinacion });
  }

  actualizarProyectosComisionesCombinaciones(combinacion: any) {
    return this.httpr.POST<any>("/proyectos/editar-combinacion-proyectos-reglas", combinacion);
  }

  guardarPeriodoValidez(periodoValidez: PeriodoValidezDto) {
    return this.httpr.POST<any>("/proyectos/guardar-periodo-validez-reglas-comision", periodoValidez);
  }

  recuperaPeriodoValidez(idProyecto: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    return this.httpr.GET<any>("/proyectos/recuperar-recupera-periodo-validez", params);
  }


  guardarHorarioProyecto(horario = new Proyecto_Reserva_Horarios()) {
    horario.horaInicioString = horario.horaInicio;
    horario.horaFinString = horario.horaFin;

    var url = environment.apiUrl;
    return this.http.post<any>(url + "/proyectos/guardar-horario-proyecto-renta", horario, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    });
  }

  recuperaHorariosProyectoRenta(idProyecto: number) {
    var url = environment.apiUrl;
    return this.http.get<any>(url + "/proyectos/recupera-horario-proyecto-renta", {
      params: new HttpParams().set('idProyecto', idProyecto.toString()),
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  recuperaHorariosProyectoLoteRenta(idProyecto: number, idLote: number) {
    var url = environment.apiUrl;
    return this.http.get<any>(url + "/proyectos/recupera-horario-proyecto-lote-renta", {
      params: new HttpParams().set('idProyecto', idProyecto.toString()).set('idLote', idLote.toString()),
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaProyectoLoteRentaPrecios(dto: Lote_Reserva_Precios): Observable<any> {
    return this.http.post(`${environment.apiUrl}/proyectos/guarda-proyecto-lote-renta-precios`, dto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    });
  }

  guardaProyectoLoteRentaReglasHorario(dto: Lote_Reserva_ReglasHorario): Observable<any> {
    return this.http.post(`${environment.apiUrl}/proyectos/guarda-proyecto-lote-reglas-horarios-reservas`, dto, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }),
    });
  }

  recuperaPreciosUnidadRenta(idProyecto: number, idLote: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    params = params.append("idLote", idLote.toString());
    return this.httpr.GET<any>("/proyectos/recupera-proyecto-reserva-lotes-precios", params);
  }

  recuperaReservasProyectoLote(idProyecto: number, idLote: number, idSeguimientoProspecto: number) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto.toString());
    params = params.append("idLote", idLote.toString());
    params = params.append("idSeguimientoProspecto", idSeguimientoProspecto.toString());

    return this.httpr.GET<any>("/proyectos/recupera-calendario-lote-reservas", params);
  }

  recuperaReglasReserva(idProyecto: number = -1, idLote: number = -1, tipoModalidad: number = -1, cantidadReserva: number = -1) {
    var params = new HttpParams();
    params = params.append("idProyecto", idProyecto?.toString());
    params = params.append("idLote", idLote?.toString());
    params = params.append("tipoModalidad", tipoModalidad?.toString());
    params = params.append("cantidadReserva", cantidadReserva?.toString());

    return this.httpr.GET<any>("/proyectos/recupera-proyecto-reserva-reglas", params);
  }

  guardaProyectoLoteRentaReglas(reglas: ProyectoReservaReglaDTO) {
    return this.httpr.POST<any>("/proyectos/guarda-proyecto-reserva-reglas", reglas);
  }

  recuperaEstatusProcesoProyecto(procesos: Proceso) {
    var params = new HttpParams();
    params = params.append("IdProyecto", procesos.idProyecto.toString());
    return this.httpr.GET<ProcesosValidadoEstatus[]>("/proyectos/recupera-estatus-procesos-proyecto", params);
  }

  eliminaProductoProyecto(producto: ProyectoProducto) {
    return this.httpr.POST<any>("/proyectos/eliminar-producto-proyecto", producto);
  }

  recuperaEventosProyectoLote(idProyecto: number, idLote: number) {
    const body = {
      idProyecto: idProyecto,
      idLote: idLote
    };
    return this.httpr.POST<any>("/proyectoLoteEvento/recupera-timeline-lote", body);
  }

  guardarEventoProyectoLote(formData: FormData) {
    const url = environment.apiUrl;
    const usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));
    const headers = new HttpHeaders().set('Authorization', `Bearer ${usuarioLogeado.token}`);

    return this.http.post<any>(url + "/proyectoLoteEvento/guardar-proyecto-lote-evento", formData, { headers })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(errorRes => {
          console.log(errorRes);
          return throwError(errorRes);
        })
      );
  }

  recuperaCatalogoLoteEventoTipo(estatus: number = 1) {
    const body = {
      estatus: estatus
    };
    return this.httpr.POST<any>("/proyectoLoteEvento/recupera-catalogo-lote-evento-tipo", body);
  }

  guardarCatalogoLoteEventoTipo(tipoEvento: any) {
    return this.httpr.POST<any>("/proyectoLoteEvento/guardar-catalogo-lote-evento-tipo", tipoEvento);
  }

  // ------------------------------------------------------------------
  guardarProyectosLoteEventosConfiguracion(configuracion: any) {
    return this.httpr.POST<any>("/proyectoLoteEvento/guardar-proyectoslote-eventos-configuracion", configuracion);
  }

  recuperaProyectosLoteEventosConfiguracion(IdProyecto: number) {
    return this.httpr.POST<any>("/proyectoLoteEvento/recupera-proyectoslote-eventos-configuracion", { IdProyecto });
  }
}
